import Styled from "styled-components";

export const PaginationDiv = Styled.div`
display:flex;
justify-content:center;
margin-top:1rem;
`;
